import { meta } from '@/helpers/constants/router';
import { OVERVIEW_ROUTE, OVERVIEW_PRODUCTS_ROUTE } from '@/helpers/constants/AffiliateRoutes';
const Overview = () => import('@/views/v2/affiliate/Overview.vue');
const Wrapper = () => import('@/views/Wrapper.vue');
const Subscription = () => import('@/components/v2/Subscription.vue');
const SettingsPageSubscription = () => import('@/views/apps/SettingsPageSubscription.vue');
export default [
    {
        path: 'overview',
        component: Wrapper,
        meta: { ...meta, title: OVERVIEW_ROUTE.title },
        children: [
            {
                path: '/',
                name: OVERVIEW_ROUTE.name,
                component: Overview,
                meta: {
                    title: 'Overview',
                },
                children: [
                    {
                        path: 'latest-sold-products',
                        name: OVERVIEW_PRODUCTS_ROUTE.name,
                        component: () => import('@/components/v2/ecommerce/LatestSoldProductsIndex.vue'),
                        meta: { title: OVERVIEW_PRODUCTS_ROUTE.title },
                    },
                ],
            },
        ],
    },
    {
        path: 'product-showcase-catalog',
        component: Wrapper,
        redirect: 'product-showcase-catalog',
        meta: { ...meta, title: 'Product Showcase Catalog' },
        children: [
            {
                path: '/',
                name: 'product-showcase-catalog',
                props: true,
                component: () => import('@/views/v2/your_store/ProductShowcaseCatalog.vue'),
                meta: {
                    title: 'Product Showcase Catalog',
                    subtitle: 'View all your catalog contents here.'
                },
            },
        ],
    },
    {
        path: 'product-marketplace',
        component: Wrapper,
        redirect: 'product-marketplace',
        meta: { ...meta, title: 'Product Marketplace' },
        children: [
            {
                path: '/',
                name: 'product-marketplace',
                props: true,
                component: () => import('@/views/v2/your_store/ProductMarketPlace.vue'),
                meta: {
                    title: 'Product Marketplace',
                    subtitle: 'View all your marketplace contents here.'
                },
            },
        ],
    },
    {
        path: 'affiliate-automation',
        component: Wrapper,
        meta: { ...meta, title: 'Comment Auto-Reply' },
        children: [
            {
                path: '/',
                name: 'affiliate-automation',
                props: true,
                component: () => import('@/views/v2/AffiliateAutomation.vue'),
                meta: {
                    title: 'Comment Auto-Reply',
                    subtitle: "View your store's Comment Auto-Reply here.",
                },
            },
            {
                path: 'create',
                name: 'add-automation',
                meta: { title: 'Add Comment Auto-Reply', subtitle: "Configure your store's Comment Auto-Reply here." },
                component: () => import('@/views/v3/prompts/CommentAutoreply.vue'),
            },
            {
                path: ':uuid',
                meta: { title: 'Comment Auto-Replyaaa' },
                component: Wrapper,
                children: [
                    {
                        path: 'edit',
                        name: 'edit-automation',
                        component: () => import('@/views/v3/prompts/CommentAutoreply.vue'),
                        props: true,
                        meta: {
                            title: 'Edit Comment Auto-Reply',
                            parentMenu: "Edit your store's Comment Auto-Reply here.",
                        },
                    },
                ],
            },
        ],
    },
    {
        path: 'affiliate-page-subscription',
        name: 'affiliate-page-subscription',
        component: Subscription,
        meta: { title: 'Connect / Disconnect ChatGenie' },
        redirect: { name: 'affiliate-facebook-page-subscription' },
        children: [
            {
                path: '/',
                name: 'affiliate-facebook-page-subscription',
                meta: {
                    title: 'Connect / Disconnect ChatGenie',
                    childTitle: 'Facebook Messenger In-App Store',
                },
                component: SettingsPageSubscription,
            },
        ],
    },
];
